export const chargeExplain = {
    "connectToBank": "Iniciar sesión en la cuenta bancaria"
};
